<template>
  <div class="col-lg-4">
    <div class="card mb-4">
      <h3 class="card-title">{{ $t('common.scent') }}</h3>
      <div class="scent">
        <div class="scent-thumbnail background-cover" :class="background"></div>
        <div class="scent-content">
          <p>
            <strong>{{ this.scent }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Scent',
  props: {
    scent: {
      type: String,
      default: 'scent',
    },
    background: {
      type: String,
      default: 'neutraal',
    },
  },
  methods: {
    boost() {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            'hub/boost/' +
            this.$route.params.hash +
            '/60'
        )
        .then(() => {
          console.info('boosting');
        })
        .catch(() => {
          console.warn('Not so much boosting..');
        });
    },
  },
};
</script>
